import styled from 'styled-components';

const EBarOtherAnnouncementsResultDiv = styled.div`
  width: 100%;
`;

EBarOtherAnnouncementsResultDiv.displayName = 'EBarOtherAnnouncementsResultDiv';

export default EBarOtherAnnouncementsResultDiv;
